import React, { cloneElement } from 'react'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { twMerge } from 'tailwind-merge'
import { useIsActive } from 'modules/header/hooks/use-is-active'

type TopMenuItemProps = {
  icon: React.ReactElement
  name: string
  href: string
  ignoreBasePath?: boolean
  className?: string
  activeClassName?: string
}

export function TopMenuItem({
  icon,
  name,
  href,
  ignoreBasePath = false,
  className,
  activeClassName,
  ...rest
}: TopMenuItemProps) {
  const isActive = useIsActive(href)
  const { t } = useTranslation()

  const Icon = cloneElement(icon, {
    ...icon.props,
    className: twMerge(icon.props.className, 'max-h-10 max-w-10'),
  })

  return React.createElement(
    ignoreBasePath ? 'a' : Link,
    {
      href: href,
      className: twMerge(
        `hidden h-full items-center gap-2 border-b-4 border-transparent text-sm font-bold text-background-secondary lg:flex`,
        className,
        isActive && twMerge(`border-brand-primary text-background-secondary`, activeClassName),
      ),
      ...rest,
    },
    <>
      {Icon}
      <span className="mt-1">{t(name)}</span>
    </>,
  )
}
